(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import ActivitiesDataModule from './components/ActivitiesDataModule';
import importData from './importData';
import getTimelineSteps from './timelineData/getTimelineSteps';
var _default = {
  id: 'plugin-activities',
  path: '/activities',
  name: t('ehr', 'Activities'),
  MenuModule: {
    name: t('ehr', 'Activities'),
    icon: 'DirectionsRun',
    priority: 90
  },
  WidgetModule: {
    name: t('ehr', 'Activities'),
    icon: 'DirectionsRun',
    priority: 90
  },
  DataModule: {
    Component: ActivitiesDataModule,
    importData: importData
  },
  TimelineModule: [{
    name: t('ehr', 'Steps'),
    color: '#58d68d',
    icon: 'DirectionsRun',
    getData: getTimelineSteps
  }]
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();